<mat-card>
  <mat-card-header>
    <mat-card-title>
      Applications
    </mat-card-title>

    <mat-card-subtitle class="filter">
      <mat-form-field class="filter-text">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
        <mat-hint>Comma seperate filter terms. (Eg. application, username)</mat-hint>
      </mat-form-field>
      <mat-slide-toggle color="accent" [checked]="showHidden" (change)="setHiddenFilter($event)">Show Hidden
        Applications</mat-slide-toggle>
    </mat-card-subtitle>

    <button class="header-button" mat-raised-button color="accent" (click)="addApp()">Add</button>
  </mat-card-header>

  <mat-card-content>

    <mat-table [dataSource]="dataSource" matSort>
      <!-- Application Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Application Name </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">Application Name:</span>
          <div class="name-container">
            <div class="app-name">{{element.name}}
              <div class="app-creationdate">
                Created: {{ element.creationdate|date:'mediumDate' }}
              </div>
            </div>
            <div class="row-actions">
              <button (click)="onEditClick(element)">Edit</button>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <!-- Description Column -->
      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Description </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">Description:</span>
          <div class="name-container">
            <div class="app-description">{{element.description}}</div>
            <div *ngIf="element.currentUserRoles.length > 0" class="app-roles">
              Roles: {{element.currentUserRoles.join(", ")}}
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row class="app-row" *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>

  </mat-card-content>

  <mat-card-actions align="end">
    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
  </mat-card-actions>
</mat-card>